export const paymentProviderNames = {
  YANDEX: "ЮKassa",
  ROBOKASSA: "Robokassa",
  STRIPE: "Stripe",
  PAYPAL: "Paypal",
};
